import { render, staticRenderFns } from "./OFooterComp.vue?vue&type=template&id=6d915261&"
import script from "./OFooterComp.vue?vue&type=script&lang=js&"
export * from "./OFooterComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports